export default __webpack_public_path__ + "static/sb-720be3bc61e44d9894ae75c32813dfc3.svg";